// extracted by mini-css-extract-plugin
export default {"slider":"homeOnline_slider__4GDw2","slide_img":"homeOnline_slide_img__TorfY","slide":"homeOnline_slide__2pu72"};